import { Button } from "atoms/button/Button";
import { Checkbox } from "atoms/checkbox/Checkbox";

import { QuizStepProps } from "../useQuestionnaire";

const checkboxList = [
  {
    name: "Reduce your caloric intake alongside medication, if clinically appropriate",
    value: "ReduceCalories",
  },
  {
    name: "Increase your physical activity alongside medication, if clinically appropriate",
    value: "IncreaseExercise",
  },
  { name: "None of the above", value: "None" },
];

export const AreWillingToChange = (props: QuizStepProps) => {
  const hasError = !!props.errors?.AreWillingToChange;
  const checkChanged = (checked: boolean, value: string) => {
    if (!props.data.AreWillingToChange) {
      props.data.AreWillingToChange = [];
    }
    if (!checked) {
      const newList = (props.data.AreWillingToChange as string[]).filter(
        (v: string) => v !== value
      );

      props.handleStepData("AreWillingToChange", newList);
    } else if (value === "None") {
      props.handleStepData("AreWillingToChange", ["None"]);
    } else if (props.data.AreWillingToChange.includes("None")) {
      props.handleStepData("AreWillingToChange", [value]);
    } else {
      props.handleStepData("AreWillingToChange", [
        ...props.data.AreWillingToChange,
        value,
      ]);
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div className="pb-8 font-serif text-h3">Are you willing to </div>
      <div>
        <div className="flex flex-col items-start">
          {checkboxList.map((checkbox) => (
            <Checkbox
              key={checkbox.value}
              textStyle="text-bold2"
              checked={props.data.AreWillingToChange?.includes(checkbox.value)}
              label={checkbox.name}
              onChange={(e) => checkChanged(e, checkbox.value)}
            />
          ))}
        </div>
      </div>
      <div hidden={!hasError}>
        <p className="mt-2 text-sm text-red">
          Please select at least one option.
        </p>
      </div>
      <div className="mt-auto">
        <Button onClick={props.next} fullWidth>
          Next Question
        </Button>
      </div>
    </div>
  );
};
